import * as wasm from "./catcolab_document_types_bg.wasm";
export * from "./catcolab_document_types_bg.js";
import { __wbg_set_wasm } from "./catcolab_document_types_bg.js";
__wbg_set_wasm(wasm);
wasm.__wbindgen_start();
